import { container } from '@shared/common/dependency-injection/domain/container';
import { MessagingModuleRoutes } from '@client/feature/messaging/application/routes/messaging.module-routes';

export const messagingRoutes = new MessagingModuleRoutes(container).getRoutes();
